const UnitedArabEmiratesSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112676)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.3042 26.957L13.0433 38.7567C15.2099 39.5607 17.5534 40.0005 19.9998 40.0005C28.599 40.0005 35.93 34.573 38.7558 26.957H11.3042Z"
        fill="black"
      />
      <path
        d="M11.3042 13.0435L13.0433 1.24383C15.2099 0.439844 17.5534 0 19.9998 0C28.599 0 35.93 5.4275 38.7558 13.0435H11.3042Z"
        fill="#6DA544"
      />
      <path
        d="M0 20.0011C0 28.6004 5.42758 35.9313 13.0435 38.7571V1.24512C5.42758 4.07098 0 11.4018 0 20.0011Z"
        fill="#A2001D"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112676">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default UnitedArabEmiratesSvg;
